import m from "./../../../dist/es2015/locales/sr_RS.js";
export const am5locales_sr_RS = m;